export const PricingModelTypesEnum = {
    STANDARD: 1,
    PRICING_RUBRIC: 2,
    LOWEST_BID: 3
};

export const PricingModelTypesList = [
    { id: PricingModelTypesEnum.STANDARD, name: "Standard" },
    { id: PricingModelTypesEnum.PRICING_RUBRIC, name: "Pricing Rubric" },
    { id: PricingModelTypesEnum.LOWEST_BID, name: "Lowest Bid" }
];

export const LoadPriceStatusEnum = {
    PENDING: 1,
    APPROVED: 2,
    REJECTED_BY_CLIENT: 3
};

export const LoadPriceStatusNames = {
    [LoadPriceStatusEnum.PENDING]: 'Pending',
    [LoadPriceStatusEnum.APPROVED]: 'Approved',
    [LoadPriceStatusEnum.REJECTED_BY_CLIENT]: 'Rejected'
};

export const getStatusColor = (status) => {
    switch (status) {
        case LoadPriceStatusEnum.PENDING:
            return { borderColor:'#BF8F00', backgroundColor: '#FFF2CC', color: '#BF8F00' };
        case LoadPriceStatusEnum.APPROVED:
            return { borderColor: '#5C9E5A', backgroundColor: '#E5F6E4', color:  '#5C9E5A'};
        case LoadPriceStatusEnum.REJECTED_BY_CLIENT:
            return { borderColor:'#E64165', backgroundColor: '#FAD9E0', color: '#E64165' };
        default:
            return {};
    }
}